<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>现金红圈配置</span>
          <el-card>
            <div slot="header" class="clearfix">
              <span>开关配置</span>
            </div>
            <el-form>
              <el-switch
                v-model="status"
                active-text="开启"
                inactive-text="关闭"
                @change="statusChange"
              />
            </el-form>
          </el-card>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-button v-permisaction="['config:redCircle:add']" size="mini" type="success" @click="dialogVisible = true">添加等级</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
              >
                <el-button v-permisaction="['config:redCircle:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:redCircle:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <clear-cache-apply />
              <sync-data />
            </el-col>
          </el-row>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-table :data="scoreItem.data" border stripe>
                        <el-table-column prop="max_open_box" label="最大开盒数量">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.max_open_box" placeholder="最大开盒数量" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="cool_down" label="冷却时间(分钟)">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.cool_down" placeholder="冷却时间" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="basic_coin" label="基础金币">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.basic_coin" placeholder="基础金币" />
                          </template>
                        </el-table-column>
                        <el-table-column align="center" width="250" prop="reset_min_val" label="重置金币基础值">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.reset_min_val" style="width: 46%" placeholder="最小值" />
                            -
                            <el-input v-model.number="scope.row.reset_max_val" style="width: 46%" placeholder="最大值" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="max_coin" label="金币上限">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.max_coin" placeholder="金币上限" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="gift" label="礼盒的概率">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.gift" placeholder="礼盒的概率" />
                          </template>
                        </el-table-column>
                        <el-table-column width="100" prop="guaranty_times" label="开箱保底次数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.guaranty_times" placeholder="开箱保底次数" />
                          </template>
                        </el-table-column>
                        <el-table-column width="100" prop="guaranty_mini" label="连续开箱倍数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.guaranty_mini" placeholder="开箱保底次数" />
                          </template>
                        </el-table-column>
                        <el-table-column width="100" prop="help_reward" label="协助奖励">
                          <template slot-scope="scope">
                            <commReward :limit-type="[15]" :limit-len="1" :value="scope.row.help_reward" />
                          </template>
                        </el-table-column>
                        <el-table-column width="130" prop="help_limit" label="帮助奖励领取次数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.help_limit" placeholder="帮助奖励领取次数" />
                          </template>
                        </el-table-column>
                        <el-table-column width="100" label="权重">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = true"> 权重</el-button>
                            <el-drawer title="权重配置/每个人的权重" size="350px" :visible.sync="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible">
                              <el-form :inline="true">
                                <el-row v-for="(config, i) in scope.row.multiple" :key="i">
                                  <el-form-item :label="'第'+ (i + 1) + '次抽奖'" style="margin-top: 10px;">
                                    <el-input v-model.number="config.multiple" style="width: 60px;" placeholder="倍数" />
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;" label="权重">
                                    <el-input v-model.number="config.v" style="width: 80px" placeholder="权重" autocomplete="off" />
                                  </el-form-item>
                                </el-row>
                              </el-form>
                              <div slot="footer" class="dialog-footer">
                                <el-button @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">取 消</el-button>
                                <el-button type="primary" @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">确 定</el-button>
                              </div>
                            </el-drawer>
                          </template>
                        </el-table-column>
                        <el-table-column width="100" label="奖励配置">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="rewardvisibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = true">奖励</el-button>
                            <el-drawer title="奖励配置" size="950px" :visible.sync="rewardvisibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible">
                              <commReward v-model="scope.row.reward" />
                              <!--                              <el-button v-permisaction="['config:roulette:add']" style="margin-top: 10px" type="primary" @click="addReward(tabItem.label,scoreItem.group_name, score_index)">+</el-button>-->
                              <div slot="footer" class="dialog-footer">
                                <el-button @click="rewardvisibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">取 消</el-button>
                                <el-button type="primary" @click="rewardvisibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">确 定</el-button>
                              </div>
                            </el-drawer>
                          </template>
                        </el-table-column>
                        <el-table-column width="100" label="最大奖励">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="maxRewardArr[tabItem.label][scoreItem.group_name][scope.$index].visible = true">最大奖励</el-button>
                            <el-drawer title="奖励配置" size="950px" :visible.sync="maxRewardArr[tabItem.label][scoreItem.group_name][scope.$index].visible">
                              <commReward v-model="scope.row.max_reward" />
                              <div slot="footer" class="dialog-footer">
                                <el-button @click="maxRewardArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">取 消</el-button>
                                <el-button type="primary" @click="maxRewardArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">确 定</el-button>
                              </div>
                            </el-drawer>
                          </template>
                        </el-table-column>
                        <el-table-column width="100" label="倍数">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="betListArr[tabItem.label][scoreItem.group_name][scope.$index].visible = true">倍数</el-button>
                            <el-drawer title="倍数配置" size="450px" :visible.sync="betListArr[tabItem.label][scoreItem.group_name][scope.$index].visible">
                              <el-form :inline="true">
                                <el-row v-for="(config, k) in scope.row.bet_list" :key="k">
                                  <el-form-item :key="k" label="倍数" style="margin-top: 10px;">
                                    <el-input v-model.number="scope.row.bet_list[k]" style="width: 130px;margin-left: 10px" placeholder="体力分块" />
                                  </el-form-item>
                                  <el-form-item :key="k" label="触发保底的倍数" style="margin-top: 10px;">
                                    <el-switch v-model="scope.row.guaranty_bet[k]" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" />
                                  </el-form-item>
                                </el-row>
                              </el-form>
                              <div slot="footer" class="dialog-footer">
                                <el-button @click="betListArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">取 消</el-button>
                                <el-button type="primary" @click="betListArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">确 定</el-button>
                              </div>
                            </el-drawer>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button v-permisaction="['config:redCircle:del']" type="danger" size="mini" @click="delEvent(tabItem.label,scoreItem.group_name , scope.$index,scope.row.id)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button v-if="scoreItem.data.length <= 0" size="mini" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                      <el-button v-permisaction="['config:redCircle:add']" size="mini" type="primary" @click="onSubmit()">保存</el-button>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import {
  delRedCircleCfgList,
  exportRedCircleCfg,
  getRedCircleCfgList,
  updateRedCircleCfg,
  importRedCircleCfg, getRedCircleStatus
} from '@/api/config/red-circle-cfg'
import { getToken } from '@/utils/auth'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import commReward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'RedCircleConfig',
  components: {
    SyncData,
    ClearCacheApply,
    commReward
  },
  data() {
    return {
      status: false,
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      visibleArr: {},
      rewardvisibleArr: {},
      betListArr: {},
      maxRewardArr: {},
      selectType: [
        { 'id': 1, 'title': '只取数量' },
        { 'id': 2, 'title': '等级取值' }
      ],
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      skinId: [62, 19, 67, 68],
      chessId: [],
      areaId: [],
      shield: [],
      sieve: []
    }
  },
  created() {
    this.getGroup()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importRedCircleCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportRedCircleCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit(noTips = false) {
      console.log('onSubmit')
      // const data = JSON.stringify(this.formData)
      // console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          const scoreItem = scoreData[i2]
          if (scoreItem.data.length <= 0) {
            continue
          }
          groupIndex++
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          if (_data.reset_min_val > _data.reset_max_val) {
            this.msgError('重置金币基础值-最小值不能大于最大值')
            return
          }

          for (const j in _data.reward) {
            const r = _data.reward[j]
            if (r.propsId === 65) {
              _data.reward[j].num *= 10000
            }
          }
          for (const j in _data.max_reward) {
            const r = _data.max_reward[j]
            if (r.propsId === 65) {
              _data.max_reward[j].num *= 10000
            }
          }
          _data.condition = key
          _postData.push(_data)
        }
      }

      console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log(postCondition)
      console.log(_postData)
      updateRedCircleCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    statusChange(val) {
      this.getStatus(val ? '1' : '0')
    },
    getStatus(status = '') {
      getRedCircleStatus({ type: status }).then(res => {
        if (res.data) {
          this.status = true
        } else {
          this.status = false
        }
      })
    },
    getTables(actName, onSubmit = false) {
      this.tabPane = []
      this.formData = []
      getRedCircleCfgList().then(res => {
        if (res.code === 200) {
          const data = res.data.data
          console.log(data)
          // const tab = {}
          const cond = res.data.cond
          const ranges = []
          for (const i in cond) {
            const val = String(i).split('-')
            ranges.push(val[0] + '-' + val[1])
          }
          const parsed = ranges
            .map(str => {
              const [start, end] = str.split('-').map(Number)
              return { start, end, raw: str }
            })
            .sort((a, b) => a.start - b.start)
          const sorted = parsed.map(item => item.raw)
          for (const i of sorted) {
            const val = cond[i]
            const levelName = val.start + '-' + val.end
            const scoreName = val.groups.join('-')

            // 初始化弹窗
            if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
              this.$set(this.visibleArr, levelName, {})
              this.$set(this.rewardvisibleArr, levelName, {})
              this.$set(this.betListArr, levelName, {})
              this.$set(this.maxRewardArr, levelName, {})
            }

            // eslint-disable-next-line no-unused-vars
            if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
              this.$set(this.formData, levelName, {})
            }

            if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
              this.$set(this.visibleArr[levelName], scoreName, [])
              this.$set(this.rewardvisibleArr[levelName], scoreName, [])
              this.$set(this.betListArr[levelName], scoreName, [])
              this.$set(this.maxRewardArr[levelName], scoreName, [])
            }

            // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
            //   this.$set(this.formData[levelName][scoreName], 'data', [])
            // }

            this.$set(this.formData[levelName], scoreName, {
              'group': val.groups,
              'group_name': scoreName,
              'group_bak': val.groups,
              data: []
            })

            for (const ii in data) {
              const _event = data[ii]
              if (_event.condition === i) {
                for (const j in _event.reward) {
                  const r = _event.reward[j]
                  if (r.propsId === 65) {
                    _event.reward[j].num /= 10000
                  }
                }
                for (const j in _event.max_reward) {
                  const r = _event.max_reward[j]
                  if (r.propsId === 65) {
                    _event.max_reward[j].num /= 10000
                  }
                }

                this.visibleArr[levelName][scoreName].push({ visible: false })
                this.rewardvisibleArr[levelName][scoreName].push({ visible: false })
                this.betListArr[levelName][scoreName].push({ visible: false })
                this.maxRewardArr[levelName][scoreName].push({ visible: false })
                this.$set(this.formData[levelName][scoreName], 'data', [_event])
              }
            }

            // 等级
            let findIndex = -1
            this.tabPane.forEach((item, index) => {
              if (item.label === levelName) {
                findIndex = index
              }
            })

            if (findIndex === -1) {
              this.tabPane.push({
                label: levelName,
                min_level: val.start,
                max_level: val.end,
                bak_min_level: val.start,
                bak_max_level: val.end,
                add: true
              })
            }
            console.log('actName', actName)
            if (actName) {
              this.levelActiveName = actName
            } else {
              this.levelActiveName = levelName
            }
          }

          // this.onSubmit(false)
        }

        this.getStatus()
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    handleRewardClose(d, levelName, scoreName, index) {
      this.rewardvisibleArr[levelName][scoreName][index].visible = false
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)
      // 修改弹窗
      const oldRewardVisle = this.rewardvisibleArr[oldLevelName]
      Vue.delete(this.rewardvisibleArr, oldLevelName)
      this.$set(this.rewardvisibleArr, newLevelName, oldRewardVisle)
      // 倍数
      const oldBetListVisle = this.betListArr[oldLevelName]
      Vue.delete(this.betListArr, oldLevelName)
      this.$set(this.betListArr, newLevelName, oldBetListVisle)
      // 最大奖励
      const oldMaxRewardVisle = this.maxRewardArr[oldLevelName]
      Vue.delete(this.maxRewardArr, oldLevelName)
      this.$set(this.maxRewardArr, newLevelName, oldMaxRewardVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'multiple': [
          { multiple: 1, v: 0, avatar_num: 0 },
          { multiple: 2, v: 0, avatar_num: 0 },
          { multiple: 3, v: 0, avatar_num: 0 },
          { multiple: 4, v: 0, avatar_num: 0 },
          { multiple: 5, v: 0, avatar_num: 0 },
          { multiple: 6, v: 0, avatar_num: 0 },
          { multiple: 7, v: 0, avatar_num: 0 },
          { multiple: 8, v: 0, avatar_num: 0 },
          { multiple: 50, v: 0, avatar_num: 0 }
        ],
        'max_open_box': 1,
        'cool_down': 0,
        'basic_coin': 0,
        'reset_min_val': 0,
        'reset_max_val': 0,
        'max_coin': 0,
        'gift': 0,
        'guaranty_times': 10,
        'guaranty_mini': 7,
        'help_reward': [],
        'help_limit': 0,
        max_reward: [],
        bet_list: [2, 3, 4, 5, 6, 7, 8, 20, 50],
        guaranty_bet: [0, 0, 0, 0, 0, 1, 1, 1, 0],
        'reward': [
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 15, 'num': 0, 'rtype': 1, 'skin': '' }
        ]
      })
      this.visibleArr[levelName][scoreName].push({ visible: false })
      this.rewardvisibleArr[levelName][scoreName].push({ visible: false })
      this.betListArr[levelName][scoreName].push({ visible: false })
      this.maxRewardArr[levelName][scoreName].push({ visible: false })
    },
    delEvent(levelName, scoreName, index, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$delete(this.formData[levelName], scoreName)
          delRedCircleCfgList({ id: id }).then(res => {
            if (res.code === 200) {
              // this.msgSuccess(res.msg)
              this.$delete(this.formData[levelName], scoreName)
              this.onSubmit(true)
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
        this.$set(this.rewardvisibleArr[score.level_name], scoreTag, [])
        this.$set(this.betListArr[score.level_name], scoreTag, [])
        this.$set(this.maxRewardArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      this.rewardvisibleArr[score.level_name][scoreTag].push({ visible: false })
      this.betListArr[score.level_name][scoreTag].push({ visible: false })
      this.maxRewardArr[score.level_name][scoreTag].push({ visible: false })
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        'multiple': [
          { multiple: 1, v: 0, avatar_num: 0 },
          { multiple: 2, v: 0, avatar_num: 0 },
          { multiple: 3, v: 0, avatar_num: 0 },
          { multiple: 4, v: 0, avatar_num: 0 },
          { multiple: 5, v: 0, avatar_num: 0 },
          { multiple: 6, v: 0, avatar_num: 0 },
          { multiple: 7, v: 0, avatar_num: 0 },
          { multiple: 8, v: 0, avatar_num: 0 },
          { multiple: 50, v: 0, avatar_num: 0 }
        ],
        'max_open_box': 1,
        'cool_down': 0,
        'basic_coin': 0,
        'max_coin': 0,
        'reset_min_val': 0,
        'reset_max_val': 0,
        'gift': 0,
        'reward': [
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' },
          { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' }
          // { 'propsId': 14, 'num': 0, 'rtype': 1, 'skin': '' }
        ],
        help_reward: [],
        help_limit: 0,
        max_reward: [],
        guaranty_times: 0,
        guaranty_mini: 0,
        guaranty_bet: [0, 0, 0, 0, 0, 1, 1, 1, 0],
        bet_list: [2, 3, 4, 5, 6, 7, 8, 20, 50]
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      console.log(this.betListArr[score.level_name][scoreTag])
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      this.$set(this.rewardvisibleArr, levelName, {})
      this.$set(this.betListArr, levelName, {})
      this.$set(this.maxRewardArr, levelName, {})
      console.log(this.formData)
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
          this.rewardType.push({ 'label': '选人', 'value': 66 })
        }
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)
      // 修改弹窗元素
      const oldRewardVisible = this.rewardvisibleArr[levelName][oldGroupName]
      this.$delete(this.rewardvisibleArr[levelName], oldGroupName)
      this.$set(this.rewardvisibleArr[levelName], newGroupName, oldRewardVisible)
      // 修改弹窗元素
      const oldBetListVisible = this.betListArr[levelName][oldGroupName]
      this.$delete(this.betListArr[levelName], oldGroupName)
      this.$set(this.betListArr[levelName], newGroupName, oldBetListVisible)
      // 修改最大奖励
      const oldMaxRewardVisible = this.maxRewardArr[levelName][oldGroupName]
      this.$delete(this.maxRewardArr[levelName], oldGroupName)
      this.$set(this.maxRewardArr[levelName], newGroupName, oldMaxRewardVisible)
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
